import {
  trigger,
  transition,
  style,
  animate,
  state,
} from '@angular/animations';

export const slideInOut = trigger('slideInOut', [
  state('hidden', style({ right: '-500px' })),
  state('visible', style({ right: '40px' })),
  transition('* => visible', [animate('500ms ease-in')]),
  transition('* => hidden', [animate('300ms ease-out')]),
]);
